import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("mobile-location-drawer__drawercontainer-2w1k2k", {
  position: "relative",
  width: "100%",
  backgroundColor: "var(--system-white)"
});
const _staticStyles2 = _cssRef("mobile-location-drawer__closebuttoncontainer-2e1gil", {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  paddingTop: "24px"
});
const _staticStyles3 = _cssRef("mobile-location-drawer__closebutton-3f13s2", {
  position: "relative"
});
const _staticStyles4 = _cssRef("mobile-location-drawer__locationrowset-0xk8p7", {
  paddingRight: "16px"
});
const _staticStyles5 = _cssRef("mobile-location-drawer__locationprimaryskeleton-3bjf7r", {
  minHeight: "2.25rem",
  width: "100%"
});
const _staticStyles6 = _cssRef("mobile-location-drawer__locationprimaryreserve-0h2jry", {
  opacity: 0
});
const _staticStyles7 = _cssRef("mobile-location-drawer__phonenumberskeleton-17l25m", {
  width: "256px",
  height: "48px"
});
const _staticStyles8 = _cssRef("mobile-location-drawer__actionbuttonsrowset-16tc86", {
  textAlign: "left",
  width: "unset",
  marginTop: "18px"
});
const _staticStyles9 = _cssRef("mobile-location-drawer__divider-383eo1", {
  marginBottom: "18px"
});
const _staticStyles0 = _cssRef("mobile-location-drawer__drawertitle-1ess7s", {
  position: "absolute",
  left: "-10000px",
  width: "1px",
  height: "1px",
  overflow: "hidden"
});
const _staticStyles1 = _cssRef("mobile-location-drawer__drawerdescription-1ess7s", {
  position: "absolute",
  left: "-10000px",
  width: "1px",
  height: "1px",
  overflow: "hidden"
});
import React from 'react';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import { CHANGE_LOCATION, YOUR_DETECTED_LOCATION, YOUR_SELECTED_LOCATION, LOCAL_CITY_LOCATION, LOCATION_PRIMARY_SKELETON_PLACEHOLDER, NATIONAL_CALL_CENTER_DISPLAY, NATIONAL_CALL_CENTER_LOCATION, PHONE_NUMBER, PHONE_NUMBER_DISPLAY } from '../../../constants';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import triggerInvoca from '../../../invoca/trigger-invoca';
import RowSet from '../../primitives/grid/row-set';
import Color, { colors } from '../../primitives/colors';
import Skeleton from '../../primitives/skeleton';
import Typography from '../../primitives/typography';
import PhoneNumber from '../../primitives/phone-number';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import StyledPillButton, { StyledPillButtonAsLink } from '../../primitives/styled-pill-button';
import Divider from '../../primitives/divider';
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '../../primitives/drawer';
import Container from '../../primitives/grid/container';
import ChangeLocationDrawer from '../../franchise/nearest/change-location-drawer';
import CloseButton from '../../primitives/close-button';
import RatingSummary from '../../franchise/nearest/rating-summary';
import formatPhoneLink, { toTelHref } from '../../utils/format-phone-link';
import type { FranchiseReviewSummary } from '../../../sourcing/testimonials/franchise-review';
const styles = {
  drawerContainer: _staticStyles,
  closeButtonContainer: _staticStyles2,
  closeButton: _staticStyles3,
  locationRowSet: _staticStyles4,
  locationPrimarySkeleton: _staticStyles5,
  locationPrimaryReserve: _staticStyles6,
  phoneNumberSkeleton: _staticStyles7,
  actionButtonsRowSet: _staticStyles8,
  divider: _staticStyles9
};
const MobileLocationDrawer = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const [locationChangeOpen, setLocationChangeOpen] = React.useState(false);
  const {
    loading: geoIsLoading,
    geo: locatorGeo,
    franchise: locatorFranchise,
    locationChangedByUser,
    isNationalCallCenter
  } = useLocator();
  const {
    hideNationalCallCenter,
    hideFranchiseLink
  } = useCtaProvider();
  const {
    isMicrosite,
    isLocalCityPage,
    franchise: micrositeFranchise
  } = useMicrosite();
  const geo = locatorGeo;
  const franchise = micrositeFranchise || locatorFranchise?.data;
  const disableChangeLocation = !!micrositeFranchise;
  const drawerRef = React.useRef(null);
  const frName = franchise?.name;
  const frPhone = franchise?.mainPhone;
  const reviewSummary = (franchise as {
    reviewSummary?: FranchiseReviewSummary;
  } | undefined)?.reviewSummary;
  const frLink = franchise?.permalink;
  const frId = franchise?.franchiseNumber;
  const locationPrimaryPending = geoIsLoading || !geo?.city || !frName;
  React.useEffect(() => {
    if (open) {
      triggerInvoca();
    }
  }, [open]);

  // Cleanup: Close drawer when component unmounts (e.g., when switching to desktop viewport)
  React.useEffect(() => () => {
    setOpen(false);
    // Remove any lingering Radix UI body attributes that block scroll
    document.body.style.removeProperty('pointer-events');
    document.body.style.removeProperty('overflow');
    document.body.removeAttribute('data-scroll-locked');
  }, [setOpen]);
  return <>
            <div ref={drawerRef} />
            {drawerRef?.current && open && <Drawer open={open} onOpenChange={isOpen => {
      if (!isOpen) {
        setOpen(false);
      }
    }}>
                    <DrawerContent placement="top" size="full" container={drawerRef?.current || undefined} animation="fade">
                        <DrawerTitle {..._mergeComponentProps({
          css: _staticStyles0
        })}>
                            Location and contact information
                        </DrawerTitle>
                        <DrawerDescription {..._mergeComponentProps({
          css: _staticStyles1
        })}>
                            View your selected location details and phone number
                        </DrawerDescription>
                        <Container {..._mergeComponentProps({
          css: styles.drawerContainer
        })}>
                            <div {..._mergeProps({
            css: styles.closeButtonContainer
          })}>
                                <CloseButton {..._mergeComponentProps({
              css: styles.closeButton,
              onClick: () => {
                setOpen(false);
              }
            })} />
                            </div>
                            <RowSet breakpoints={{
            dt: {
              between: 20
            }
          }}>
                                <Typography fontSize="2xl" fontWeight="medium" color="primaryOrange">
                                    24/7 Emergency Service
                                </Typography>
                                <Divider />
                                <RowSet {..._mergeComponentProps({
              breakpoints: {
                dt: {
                  between: 8
                }
              },
              css: styles.locationRowSet
            })}>
                                    <Color color="primaryOrange">
                                        {isLocalCityPage && !hideFranchiseLink && LOCAL_CITY_LOCATION}
                                        {locationChangedByUser && !isLocalCityPage && !hideFranchiseLink && !isNationalCallCenter && YOUR_SELECTED_LOCATION}
                                        {!locationChangedByUser && !isLocalCityPage && !hideFranchiseLink && !isNationalCallCenter && YOUR_DETECTED_LOCATION}
                                        {(hideFranchiseLink || isNationalCallCenter) && !isLocalCityPage && NATIONAL_CALL_CENTER_LOCATION}
                                    </Color>
                                    {!isNationalCallCenter && !isLocalCityPage && !hideFranchiseLink && <Skeleton {..._mergeComponentProps({
                css: styles.locationPrimarySkeleton,
                "aria-busy": geoIsLoading
              })}>
                                            {locationPrimaryPending && <Typography {..._mergeComponentProps({
                  fontSize: "3xl",
                  fontWeight: "medium",
                  css: styles.locationPrimaryReserve,
                  "aria-hidden": true
                })}>
                                                    {LOCATION_PRIMARY_SKELETON_PLACEHOLDER}
                                                </Typography>}
                                            {!locationPrimaryPending && !locationChangedByUser && <Typography fontSize="3xl" fontWeight="medium">
                                                    {geo.city}
                                                    {geo?.stateShort ? ', ' : ' '}
                                                    {geo?.stateShort || ''}
                                                </Typography>}
                                            {!locationPrimaryPending && locationChangedByUser && <Typography fontSize="3xl" fontWeight="medium">
                                                    {frName}
                                                </Typography>}
                                        </Skeleton>}
                                    {isLocalCityPage && <Skeleton {..._mergeComponentProps({
                css: styles.locationPrimarySkeleton
              })}>
                                            <Typography fontSize="3xl" fontWeight="medium">
                                                {franchise?.address?.city}
                                                {franchise?.address?.state ? ', ' : ' '}
                                                {franchise?.address?.state || ''}
                                            </Typography>
                                        </Skeleton>}
                                    {(hideFranchiseLink || isNationalCallCenter) && !isLocalCityPage && <Typography fontSize="3xl" fontWeight="medium">
                                            {NATIONAL_CALL_CENTER_DISPLAY}
                                        </Typography>}
                                    {(!isNationalCallCenter && !hideFranchiseLink && !locationChangedByUser || isLocalCityPage) && <Skeleton>
                                            {frName && <Typography fontSize="base">{frName}</Typography>}
                                        </Skeleton>}
                                    {reviewSummary?.shouldDisplay && !hideFranchiseLink && !isNationalCallCenter && typeof reviewSummary.rating === 'number' && typeof reviewSummary.count === 'number' && <RatingSummary count={reviewSummary.count} rating={reviewSummary.rating} />}
                                </RowSet>
                                <Skeleton {..._mergeComponentProps({
              css: styles.phoneNumberSkeleton,
              isButton: true,
              backgroundColor: "primaryOrange"
            })}>
                                    {frPhone && !hideFranchiseLink && <PhoneNumber as={StyledButtonAsLink} dialNumber={frPhone} to={toTelHref(frPhone)} aria-label={`Call ${formatPhoneLink(frPhone)}`}>
                                            {formatPhoneLink(frPhone)}
                                        </PhoneNumber>}
                                    {hideFranchiseLink && <PhoneNumber as={StyledButtonAsLink} dialNumber={PHONE_NUMBER} to={toTelHref(PHONE_NUMBER)} aria-label={`Call ${PHONE_NUMBER_DISPLAY}`}>
                                            {PHONE_NUMBER_DISPLAY}
                                        </PhoneNumber>}
                                </Skeleton>
                            </RowSet>
                            <RowSet {..._mergeComponentProps({
            breakpoints: {
              dt: {
                between: 18
              }
            },
            css: styles.actionButtonsRowSet
          })}>
                                {!!frId && !hideFranchiseLink && frLink && <>
                                        <StyledPillButtonAsLink to={frLink}>
                                            Find Out More ›
                                        </StyledPillButtonAsLink>
                                        <Divider />
                                    </>}
                                {!disableChangeLocation && !hideFranchiseLink && !isLocalCityPage && <div>
                                        <Divider {..._mergeComponentProps({
                css: styles.divider
              })} />
                                        <div>
                                            Need help elsewhere?
                                            {' '}
                                        </div>
                                        <StyledPillButton className="change-location-open-cta" onClick={() => {
                setLocationChangeOpen(true);
              }}>
                                            {CHANGE_LOCATION}
                                            {' '}
                                            ›
                                        </StyledPillButton>
                                    </div>}
                                {isLocalCityPage && <div>
                                        <div>
                                            Need help elsewhere?
                                            {' '}
                                        </div>
                                        <StyledPillButtonAsLink to="/locations">
                                            {CHANGE_LOCATION}
                                            {' '}
                                            ›
                                        </StyledPillButtonAsLink>
                                    </div>}
                                {(!hideNationalCallCenter && !isMicrosite && !isNationalCallCenter && !hideFranchiseLink || isLocalCityPage) && <>
                                        <Divider />
                                        <Typography fontSize="3xl" fontWeight="medium">
                                            {NATIONAL_CALL_CENTER_DISPLAY}
                                        </Typography>
                                        <StyledButtonAsLink to={toTelHref(PHONE_NUMBER_DISPLAY)}>
                                            {PHONE_NUMBER_DISPLAY}
                                        </StyledButtonAsLink>
                                    </>}
                            </RowSet>
                        </Container>
                    </DrawerContent>
                </Drawer>}
            <ChangeLocationDrawer visible={locationChangeOpen && open} onClose={() => setLocationChangeOpen(false)} />
        </>;
};
export default MobileLocationDrawer;